import { useEffect, useState } from "react";

import useShipping from "@checkout/hooks/useShipping";

export const useTrialBlockingCheckout = () => {
  const { isFreeTrial, isTrialEligible } = useShipping();
  const [isTrialBlockingCheckout, setIsTrialBlockingCheckout] = useState(false);

  useEffect(() => {
    setIsTrialBlockingCheckout(isFreeTrial && isTrialEligible === false);
  }, [isFreeTrial, isTrialEligible]);

  return { isTrialBlockingCheckout };
};
